/**
 * EventBus — lightweight pub/sub for inter-module communication.
 *
 * ES module. Loaded via <script type="module"> in index.html, which means it is
 * deferred: it executes after every classic script, but before DOMContentLoaded.
 * Every consumer in this codebase subscribes or emits from inside a function
 * called on or after DOMContentLoaded, so the shim below is in place in time.
 */

const _listeners = {};

export function on(event, fn) {
    (_listeners[event] = _listeners[event] || []).push(fn);
}

export function off(event, fn) {
    if (!_listeners[event]) return;
    _listeners[event] = _listeners[event].filter(f => f !== fn);
}

export function emit(event, data) {
    (_listeners[event] || []).forEach(fn => {
        try { fn(data); } catch (err) { console.error(`[EventBus] Error in "${event}" listener:`, err); }
    });
}

export const EventBus = { on, off, emit };

// Transition shim (AGENTS.md SKILL 1). Classic scripts still reach this through
// the global — storage.js does `window.EventBus?.emit(...)`. Remove only once
// nothing references the global.
if (typeof window !== 'undefined') window.EventBus = EventBus;
